import { frontendURL } from 'dashboard/helper/URLHelper';
import FunnelsPage from './FunnelsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/funnels'),
    name: 'funnels_index',
    component: FunnelsPage,
    meta: {
      permissions: ['administrator', 'flow_manage'],
    },
  },
];
